<template>
    <div>
        <div v-if="token_exists">
            <statements-report-table :api_base_path="api_base_path" :fetch_starshop="fetch_starshop"></statements-report-table>
        </div>
        <div v-else>
            {{ $t('label.token_does_not_exist') }}
        </div>
    </div>
</template>

<script>
import {ApiUrl, walletService} from "@/common/api.service";
    import StatementsReportTable from "../statements-report-table";
    import {walletReportType} from "@/constants/WalletReportType";
import keshavarzi from "@/views/wallets/AyandeWallets/Admin/components/statements/keshavarzi.vue";

    export default {
        components: {
            keshavarzi,
            StatementsReportTable,
        },
        props: {
            fetch_starshop: {
                default: false,
                type: Boolean
            },
            api_base_path: {
                default: ApiUrl.path(''),
                type: String
            }
        },
        data() {
            return {
                token_exists: false,
                walletReportType,
            };
        },
        mounted() {
            let params = {
                wallet_prefix: 'A',
                type: walletReportType.STATEMENT,
            };

            const reportAccess = this.fetch_starshop
                ? walletService.getStarShopReportAccess
                : walletService.getReportAccess;

            reportAccess(params).then(res => {
                this.token_exists = res.data.data.token_exists;

                if (! this.token_exists) {
                    window.location = res.data.data.url;
                }
            });
        },
    }
</script>
